import React from "react";
import { AccountSettingsFormData } from "../../hooks/useAccountSettings";
import {
  Box,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography
  } from "@mui/material";
import { LoadingButton } from "@mui/lab";

interface PasswordSectionProps {
  formData: AccountSettingsFormData;
  formErrors: Record<string, string>;
  isSaving: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangePassword: () => Promise<void>;
}

export default function PasswordSection({
  formData,
  formErrors,
  isSaving,
  onChange,
  onChangePassword,
}: PasswordSectionProps) {
  // Pola do zmiany hasła
  const passwordFields = [
    {
      name: "oldPassword",
      label: "Stare hasło",
      type: "password",
      required: true,
      autoComplete: "current-password",
    },
    {
      name: "newPassword",
      label: "Nowe hasło",
      type: "password",
      required: true,
      autoComplete: "new-password",
    },
    {
      name: "repeatedNewPassword",
      label: "Powtórz nowe hasło",
      type: "password",
      required: true,
      autoComplete: "new-password",
    },
  ];

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onChangePassword();
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
          Zmiana hasła
        </Typography>

        <form onSubmit={handleSubmit}>
          {/* Ukryte pole username dla dostępności - pomaga menedżerom haseł */}
          <input
            type="text"
            name="username"
            autoComplete="username"
            style={{ display: "none" }}
            tabIndex={-1}
            aria-hidden="true"
          />
          <Grid container spacing={2}>
            {passwordFields.map((f) => (
              <Grid item xs={12} sm={6} key={f.name}>
                <TextField
                  fullWidth
                  name={f.name}
                  label={f.label}
                  type={f.type}
                  required={f.required}
                  value={formData[f.name as keyof AccountSettingsFormData] || ""}
                  onChange={onChange}
                  helperText={formErrors[f.name]}
                  error={!!formErrors[f.name]}
                  size="small"
                  inputProps={{ autoComplete: f.autoComplete }}
                />
              </Grid>
            ))}
          </Grid>

          {formErrors.passwordChange && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {formErrors.passwordChange}
            </Typography>
          )}

          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <LoadingButton type="submit" variant="outlined" loading={isSaving}>
              Zmień hasło
            </LoadingButton>
          </Box>
        </form>
      </CardContent>
    </Card>
  );
}
